export default class PATH_CONFIG  {
    static USERS = '/users';
    static PRODUCTS = '/products';
    static ACCOUNTS = '/accounts';
    static API_PRODUCTS = '/apigee-services';
}


// WEBPACK FOOTER //
// ./src/services/path-config.js